declare const __PROJECT_NAME__: string | undefined;

import { PostMessage } from '../../types';
import log from '../log';

// Safe when __PROJECT_NAME__ wasn't injected by DefinePlugin (e.g. wrong build)
let nextMessageId = 0;

const sendMessage = (msg: PostMessage, target: WindowProxy | null) => {
  const projectName =
    typeof __PROJECT_NAME__ !== 'undefined' ? __PROJECT_NAME__ : 'unknown';

  const messageId = `${projectName}-${nextMessageId++}`;

  const message = { id: messageId, ...msg };

  log(`Sending message:`, message);

  target?.postMessage(JSON.stringify(message), '*');
};

export default sendMessage;
